import styled, {css} from 'styled-components';

const MessageInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(8px);

  ${(props) => props.disabled && css`
    opacity: 0.5;
    pointer-events: none;
  `}
`;

const Input = styled.textarea`
  flex: 1;
  padding: 10px 14px;
  margin-right: 8px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  outline: none;
  resize: none;
  font-family: inherit;
  font-size: 16px; /* >=16px prevents iOS Safari zoom-on-focus */
  background-color: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  height: auto;
  min-height: 25px;
  max-height: 100px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    border-color: rgba(59, 130, 246, 0.6);
  }

  @keyframes blink_input_opacity_to_prevent_scrolling_when_focus {
    0% { opacity: 0; }
    1% { opacity: 1; }
    100% { opacity: 1; }
  }

  ${(props) => props.disabled && css`
    opacity: 0.5;
  `}

  //&:focus {
  //  animation: blink_input_opacity_to_prevent_scrolling_when_focus 0.01s;
  //}
`;

const SendButton = styled.button`
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  border: none;
  border-radius: 16px;
  padding: 10px 16px;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 600;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`;

export { MessageInputContainer, Input, SendButton };
